import { LoaderFunctionArgs, Outlet } from 'react-router';

import { consoleAppConfig } from '@/console/app/config/console-app-config';
import { AuthenticatedRoute } from '@/console/app/protected-route/authenticated-route';
import { ConsoleSidebar } from '@/console/features/console-sidebar/console-sidebar';
import { ErrorBoundaryRoute } from '@/shared/app/routes/error-boundary/error-boundary';
import { FullscreenLoader } from '@/shared/components/ui/fullscreen-loader/fullscreen-loader';
import { AppConfigProvider } from '@/shared/features/app-config/context/app-config-context';
import { TCustomRouteObject } from '@/shared/types/router.types';

export const ideaasRoute: TCustomRouteObject = {
  path: '/ideaas/:sessionId',
  Component: () => (
    <AppConfigProvider value={consoleAppConfig}>
      <AuthenticatedRoute>
        <Outlet />
      </AuthenticatedRoute>
    </AppConfigProvider>
  ),
  hydrateFallbackElement: <FullscreenLoader />,
  errorElement: (
    <AppConfigProvider value={consoleAppConfig}>
      <ErrorBoundaryRoute sidebar={<ConsoleSidebar />} />
    </AppConfigProvider>
  ),
  children: [
    {
      index: true,
      lazy: async () => {
        const { IdeaasRoute } = await import('./ideaas');
        return { Component: IdeaasRoute };
      },
      loader: async (args: LoaderFunctionArgs) => {
        const { ideaasLoader } = await import('./ideaas');
        return ideaasLoader(args);
      },
    },
  ],
};
